import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { formatDayText } from '../model';
import TreatmentStartNote, {
    type TreatmentStartNoteProps,
} from './TreatmentStartNote';

/**
 * A treatment start as a calendar day in the user's locale, with how far off
 * it is beneath. Renders nothing without a start.
 */
export default function TreatmentStart(props: TreatmentStartNoteProps) {
    const intl = useIntl();
    if (!props.patient.treatmentStart) {
        return null;
    }
    return (
        <>
            <Typography variant="monoMeta" sx={{ color: 'text.primary' }}>
                {formatDayText(intl, props.patient.treatmentStart)}
            </Typography>
            <TreatmentStartNote {...props} />
        </>
    );
}
